import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class SearchService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('Search');
	}
	
	search(searchObj: TooBig4Car.Logic.SearchVM) : Observable<TooBig4Car.Logic.SearchResult[]>{
		var custID = searchObj.CustomerAccountID;
		if (this.myBaseService.configData.IsEmptyGuid(custID)) {
			searchObj.CustomerAccountID = null;
		}
		return this.myBaseService.post(searchObj, this.url, false);
	}

	searchSidemarks(searchObj: TooBig4Car.Logic.SearchBaseVM): Observable<TooBig4Car.Logic.SearchResultBase[]> {
		var custID = searchObj.CustomerAccountID;
		if (this.myBaseService.configData.IsEmptyGuid(custID)) {
			searchObj.CustomerAccountID = null;
		}
		return this.myBaseService.post(searchObj, this.url + '/Sidemark', false);
	}
}
				
